module.exports = __webpack_public_path__ + "img/gift.721a217a.svg";